import { createFilterOptions } from '@mui/material/Autocomplete';

const filterOptions = createFilterOptions();

export const getSingleFilteredOption = (options, inputValue, getOptionLabel) => {
  const filteredOptions = filterOptions(options, {
    getOptionLabel,
    inputValue,
  });

  return filteredOptions.length === 1 ? filteredOptions[0] : null;
};

export const getToggledSelection = (currentSelection, optionToToggle, isOptionEqualToValue) => {
  const isSelected = currentSelection.some(selectedOption =>
    isOptionEqualToValue(optionToToggle, selectedOption)
  );

  return isSelected
    ? currentSelection.filter(
        selectedOption => !isOptionEqualToValue(optionToToggle, selectedOption)
      )
    : [...currentSelection, optionToToggle];
};

export const handleSingleOptionEnterToggle = (
  event,
  singleFilteredOption,
  selectedValues,
  onChangeSelection,
  isOptionEqualToValue
) => {
  if (event.key !== 'Enter' || !singleFilteredOption || event.nativeEvent?.isComposing) {
    return;
  }

  Object.assign(event, { defaultMuiPrevented: true });
  event.preventDefault();
  onChangeSelection(
    getToggledSelection(selectedValues, singleFilteredOption, isOptionEqualToValue)
  );
};
